<template>
  <v-container>
    <form
      id="payment-form"
      action="/charge"
      method="post"
    >
      <div class="form-row">
        <label for="card-element">
          Credit card
        </label>
        <div id="card-element">
          <!-- A Stripe Element will be inserted here. -->
        </div>

        <!-- Used to display form errors. -->
        <div
          id="card-errors"
          role="alert"
        />
      </div>
    </form>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    isPlatform: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([ 'getSessionAccount' ])
  },
  data() {
    return {
      card: null,
      _stripe: null,
      _elements: null,
    }
  },
  mounted() {
    const options = {
      stripeAccount: this.isPlatform ? undefined : this.getSessionAccount
    }

    // Create a Stripe client.
    const stripe = Stripe(process.env.VUE_APP_STRIPE_PUB_KEY, options)

    // Create an instance of Elements.
    const elements = stripe.elements()

    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    const style = {
      base: {
        color: '#ffffff',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    }

    // Create an instance of the card Element.
    const card = elements.create('card', { style })

    // Add an instance of the card Element into the `card-element` <div>.
    card.mount('#card-element')

    // Handle real-time validation errors from the card Element.
    card.addEventListener('change', (event) => {
      const displayError = document.getElementById('card-errors')

      displayError.textContent = event.error ? event.error.message : ''
    })

    this.card = card
    this._stripe = stripe
    this._elements = elements
  },
  methods: {
    async createToken() {
      let token = null

      await this._stripe.createToken(this.card)
        .then((result) => {
          if (result.error) {
            // Inform the user if there was an error.
            const errorElement = document.getElementById('card-errors')
            errorElement.textContent = result.error.message
          } else {
            // Send the token to your server.

            console.log('token is ', result.token)
            token = result.token
            // stripeTokenHandler(result.token);
          }
        })
        .catch(e => {
          console.log('=== STRIPE ERROR')
          console.log(e)
        })

      return token
    }
  }
}
</script>
